





























































import { Component, Vue } from 'vue-property-decorator'
import { namespace, Getter } from 'vuex-class'
import AvatarImage from 'vuecomponents/avatar_image.vue'
import SurfaceActivitySvg from 'vuecomponents/surface-activity-svg.vue'

@Component({
  components: {
    AvatarImage,
    SurfaceActivitySvg,
  },
})
export default class SurfaceActivityIndicator extends Vue {
  @(namespace('contributingStatus').Getter) activeContributorsList!: string[]
  @(namespace('contributingStatus').Getter) numberOfActiveContributors!: number
  @(namespace('contributingStatus').Getter) xActivityIndicator!: boolean
  @Getter backgroundColor!: string
  @Getter backgroundLuminance!: 'light' | 'dark'
}
